import * as React from 'react';
import { usePopover } from './Popover';
export const PopoverTrigger = ({ children, }) => {
    if (!(React.isValidElement(children) && children?.props))
        throw new Error('Popover trigger is not a valid react element');
    const { triggerRef, onOpenChange, isOpen } = usePopover();
    const isOpenRef = React.useRef(isOpen);
    React.useEffect(() => {
        isOpenRef.current = isOpen;
    }, [isOpen]);
    React.useEffect(() => {
        const el = triggerRef.current;
        const onMouseDown = () => onOpenChange(!isOpenRef.current);
        const onKeyDown = (event) => {
            if (['Enter', 'Space'].includes(event.code)) {
                onOpenChange(!isOpenRef.current);
            }
        };
        el.addEventListener('mousedown', onMouseDown);
        el.addEventListener('keydown', onKeyDown);
        return () => {
            el?.removeEventListener('mousedown', onMouseDown);
            el?.removeEventListener('keydown', onKeyDown);
        };
    }, []);
    return React.cloneElement(children, {
        ref: triggerRef,
        'aria-expanded': isOpen,
    });
};
PopoverTrigger.displayName = 'PopoverTrigger';
//# sourceMappingURL=PopoverTrigger.js.map